import { get } from 'lodash'
import { saveAs } from 'file-saver'
import { STATUS } from '@/configs/constant'

export const getISODateFormat = (date) => {
  let month = '' + (date.getMonth() + 1)
  let day = '' + date.getDate()
  let year = date.getFullYear()

  if (month.length < 2) {
    month = `0${month}`
  }

  if (day.length < 2) {
    day = `0${day}`
  }

  return `${year}-${month}-${day}`
}

export const numberFormat = (value, suffix = '') => {
  if (!value) {
    return 0
  }

  let intValue = Number(value).toFixed(0)
  let result = intValue.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  let valueArr = value.toString().split('.')

  if (valueArr.length === 2) {
    let decimal = valueArr[1]
    if (decimal.length === 1) {
      decimal = `${decimal}0`
    }

    result = `${result}.${decimal}`
  }

  return `${result}${suffix}`
}

export const bindData = (object, key, defaultValue = '-') => {
  const value = get(object, key, defaultValue)
  return (value.trim() === '') ? defaultValue : value
}

export const sortDataList = (dataList, sortKey, sortBy = 'ascending') => {
  let sortedList = [...dataList]

  sortedList.sort((prev, next) => {
    const prevData = get(prev, sortKey, '')
    const nextData = get(next, sortKey, '')

    if (prevData === '' || nextData === '') {
      return 0
    }

    if (prevData < nextData) {
      const result = (sortBy === 'ascending') ? -1 : 1
      return result
    }

    if (prevData > nextData) {
      const result = (sortBy === 'ascending') ? 1 : -1
      return result
    }

    return 0
  })

  return sortedList
}

export const getStatusName = (status) => {
  switch (status) {
    case STATUS.ENABLE:
      return 'STATUS.ENABLE'
    case STATUS.DISABLE:
      return 'STATUS.DISABLE'
    default:
      return 'STATUS.UNKNOWN'
  }
}

export const forceDownloadFileUrl = (fileUrl, fileName) => {
  const link = document.createElement('a')
  link.href = fileUrl.toString()
  link.setAttribute('download', fileName)

  document.body.appendChild(link)
  link.click()

  window.URL.revokeObjectURL(link.href)
  document.body.removeChild(link)
}

export const downloadAsMSWord = (fileContent, fileName) => {
  const documentType = {
    type: 'application/vnd.ms-word;charset=utf-8'
  }
  const blob = new Blob([fileContent], documentType)
  saveAs(blob, fileName)
}

export const getImageData = (elementId, isStaticHeight = false) => {
  const maxWidth = 2
  const maxHeight = 2
  const image = document.getElementById(elementId)
  const imageUrl = get(image, 'src', '')
  const imageWidth = get(image, 'naturalWidth', 0)
  const imageHeight = get(image, 'naturalHeight', 0)

  let convertedWidth = maxWidth
  let convertedHeight = maxHeight

  if (imageWidth > imageHeight) {
    convertedWidth = maxWidth
    convertedHeight = (imageHeight / imageWidth) * convertedWidth
  }

  if (imageWidth < imageHeight) {
    convertedHeight = maxHeight
    convertedWidth = (imageWidth / imageHeight) * convertedHeight
  }

  if (isStaticHeight) {
    convertedHeight = 2
    convertedWidth = (imageWidth / imageHeight) * convertedHeight
  }

  const data = {
    url: imageUrl,
    width: convertedWidth,
    height: convertedHeight
  }

  return data
}

export const delay = (millisec) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true)
    }, millisec)
  })
}

export const periodOverlap = (periodList) => {
  const sortedPeriod = periodList.sort((previous, current) => {
    const previousTime = new Date(previous.startDate).getTime()
    const currentTime = new Date(current.startDate).getTime()
    if (previousTime < currentTime) {
      return -1
    }
    if (previousTime === currentTime) {
      return 0
    }
    return 1
  })

  for (let index in sortedPeriod) {
    if (parseInt(index) > 0) {
      const previous = sortedPeriod[index - 1]
      const current = sortedPeriod[index]
      const previousEnd = new Date(previous.endDate).getTime()
      const currentStart = new Date(current.startDate).getTime()
      const overlap = (previousEnd >= currentStart)
      if (overlap === true) {
        return true
      }
    }
  }
  return false
}

export const getDefaultSelectedList = (dataList) => {
  const selectedItemList = dataList.filter(item => (item.isDefault === 1))

  return selectedItemList
}

export const getValidPeriodList = (periodList) => {
  const validPeriodList = periodList.filter((item) => {
    const periodStartDate = get(item, '0', '')
    const periodEndDate = get(item, '1', '')
    const isValidPeriod = (periodStartDate !== '' && periodEndDate !== '')

    return isValidPeriod
  })

  return validPeriodList
}

export const preparePeriodList = (periodList) => {
  const newPeriodList = periodList.map((item) => {
    const startDate = get(item, '[0]', '')
    const endDate = get(item, '[1]', '')

    const periodOfStay = {
      startDate: startDate,
      endDate: endDate
    }

    return periodOfStay
  })

  return newPeriodList
}

export const getContractRemark = (contractDetail, remarkType) => {
  const remarkList = get(contractDetail, 'remarkList', [])
  const remarkContent = _getRemarkByType(remarkList, remarkType)

  return remarkContent
}

export const getDefaultRemark = (remarkList, remarkType) => {
  const remarkContent = _getRemarkByType(remarkList, remarkType)

  return remarkContent
}

export const filterDisableList = (list) => {
  if (list === undefined) {
    return []
  }

  return list.filter(item => {
    const isEnable = get(item, 'isEnable', STATUS.DISABLE)
    return isEnable !== STATUS.DISABLE
  })
}

export const dynamicSort = (property) => {
  let sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
    return result * sortOrder
  }
}

const _getRemarkByType = (remarkList, remarkType) => {
  const remark = remarkList.find(item => item.remarkType === remarkType)
  const remarkContent = get(remark, 'content', '')

  return remarkContent
}
